import { serviceMaker, methods, api } from "@/http/index.js";

export const getAllGroupTickets = () =>
    serviceMaker(`/group-tickets/getall`, methods.GET, api.NGB);

export const getGroupTickets = (payload) =>
    serviceMaker(`/group-tickets/tickets?region=${payload.region}&categoryId=${payload.categoryId}&subcategoryId=${payload.subCategoryId}`, methods.GET, api.NGB);

export const createGroupTicket = (payload) =>
    serviceMaker(`/group-tickets/create`, methods.POST, api.NGB, payload);

export const getGroupTicketById = (id) =>
    serviceMaker(`/group-tickets/${id}`, methods.GET, api.NGB);

export const updateGroupTicket = (id, payload) =>
    serviceMaker(`/group-tickets/${id}`, methods.PUT, api.NGB, payload);

export const deleteGroupTicket = (id, forceDelete) =>{
    let url = `/group-tickets/${id}`;
    if (forceDelete) {
        url += `?forceDelete=true`;
    }
    return serviceMaker(url, methods.DELETE, api.NGB);
}
    
export const UnlinkTicket = (id, payload) =>
    serviceMaker(`/group-tickets/${id}/unlink`, methods.PUT, api.NGB, payload);
export const LinkTicket = (id, payload) =>
    serviceMaker(`/group-tickets/${id}/link`, methods.PUT, api.NGB, payload);

export const getGroupTicketDateFilter = (date) =>
  serviceMaker(`/group-tickets/getall?startDate=${date.startDate}&endDate=${date.endDate}`, methods.GET, api.NGB);